import React from 'react';
import { Bot, User } from 'lucide-react';

const CoachMessageBubble = ({ message }) => {
  const isUser = message.role === 'user';

  return (
    <div className={`flex gap-2 ${isUser ? 'justify-end' : 'justify-start'}`}>
      {!isUser && (
        <span className="mt-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-fuchsia-500/20 text-fuchsia-200">
          <Bot size={15} aria-hidden="true" />
        </span>
      )}
      <div
        className={`max-w-[82%] rounded-lg px-3 py-2 text-sm leading-relaxed shadow-lg ${
          isUser
            ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white'
            : 'border border-white/10 bg-white/10 text-purple-50 backdrop-blur-lg'
        }`}
      >
        {message.content}
      </div>
      {isUser && (
        <span className="mt-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white/10 text-purple-100">
          <User size={15} aria-hidden="true" />
        </span>
      )}
    </div>
  );
};

export default CoachMessageBubble;
